import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { PROJECT_FILES_QUERY } from './useProjectFiles';

const DELETE_PROJECT_FILE_MUTATION = gql`
  mutation DeleteProjectFile($id: ID!) {
    deleteProjectFile(id: $id) {
      success
    }
  }
`;

export function useDeleteProjectFile(projectId: string) {
  const [deleteMutation, { loading, error }] = useMutation(DELETE_PROJECT_FILE_MUTATION, {
    refetchQueries: [{ query: PROJECT_FILES_QUERY, variables: { projectId } }],
  });

  const deleteProjectFile = async (id: string) => {
    const { data } = await deleteMutation({ variables: { id } });
    return (data as { deleteProjectFile: { success: boolean } }).deleteProjectFile.success;
  };

  return { deleteProjectFile, loading, error };
}
